<template>
  <div class="module page-wrapper">
    <div class="container">
      <div class="row">
        <el-row :gutter="48" class="section1">
          <el-col :span="12" :xs="{span: 24}">
            <img src="../../assets/module_wb201.png" alt="">
          </el-col>
          <el-col :span="12" :xs="{span: 24}">
            <div class="plain">
              <p><span>名称</span><span>智能照明模块  DY-WB201</span></p>
              <p><span>无线类型</span><span>WI-FI&amp;BLE</span></p>
              <p><span>工作电压</span><span>输入220V，输出3.3V</span></p>
              <p><span>天线类型</span><span>板载天线</span></p>
              <p><span>产品特点</span><span>直插高压驱动板，可外接红外模块</span></p>
              <p><span>产品尺寸</span><span>30*14*10mm</span></p>
              <p><span>适用范围</span><span>吊灯、吸顶灯、灯带</span></p>
            </div>
            <div class="feature">
              <div>
                <img src="../../assets/icon_gaoya.png" alt="">
                <label for="">高压强电</label>
              </div>
              <div>
                <img src="../../assets/icon_jicha.png" alt="">
                <label for="">即插即用</label>
              </div>
              <div>
                <img src="../../assets/icon_wxwg.png" alt="">
                <label for="">无需网关</label>
              </div>
              <div>
                <img src="../../assets/icon_ldzn.png" alt="">
                <label for="">联动智能</label>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="48"  class="section1">
          <el-col :span="12" :xs="{span: 24}">
            <img src="../../assets/module_b3132.png" alt="">
          </el-col>
          <el-col :span="12" :xs="{span: 24}">
            <div class="plain">
              <p><span>名称</span><span>蓝牙模块  DY-B3132</span></p>
              <p><span>无线类型</span><span>BLE</span></p>
              <p><span>工作电压</span><span>1.8V-3.6V</span></p>
              <p><span>天线类型</span><span>板载天线</span></p>
              <p><span>产品特点</span><span>Hi-Link认证模块</span></p>
              <p><span>产品尺寸</span><span>17*12.6*3mm</span></p>
              <p><span>适用范围</span><span>智能照明、智能家居、传感器</span></p>
            </div>
            <div class="feature">
              <div>
                <img src="../../assets/icon_ccdj.png" alt="">
                <label for="">超长待机</label>
              </div>
              <div>
                <img src="../../assets/icon_jicha.png" alt="">
                <label for="">即插即用</label>
              </div>
              <div>
                <img src="../../assets/icon_wxwg.png" alt="">
                <label for="">无需网关</label>
              </div>
              <div>
                <img src="../../assets/icon_ldzn.png" alt="">
                <label for="">联动智能</label>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="48"  class="section1">
          <el-col :span="12" :xs="{span: 24}">
            <img src="../../assets/module_wbe3.png" alt="">
          </el-col>
          <el-col :span="12" :xs="{span: 24}">
            <div class="plain">
              <p><span>名称</span><span>WI-FI&amp;蓝牙模块  DY-WBE3</span></p>
              <p><span>无线类型</span><span>WI-FI&amp;BLE</span></p>
              <p><span>工作电压</span><span>3.0V&amp;3.6V</span></p>
              <p><span>天线类型</span><span>无需网关，可支持红外模块</span></p>
              <p><span>产品特点</span><span>Hi-Link认证模块</span></p>
              <p><span>产品尺寸</span><span>24*16*3mm</span></p>
              <p><span>适用范围</span><span>智能楼宇、智能家居/家电、智能插座、 智慧灯、工业无线控制</span></p>
            </div>
            <div class="feature">
              <div>
                <img src="../../assets/icon_jicha.png" alt="">
                <label for="">即插即用</label>
              </div>
              <div>
                <img src="../../assets/icon_wxwg.png" alt="">
                <label for="">无需网关</label>
              </div>
              <div>
                <img src="../../assets/icon_hwyk.png" alt="">
                <label for="">红外遥控</label>
              </div>
              <div>
                <img src="../../assets/icon_ldzn.png" alt="">
                <label for="">联动智能</label>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="48"  class="section1">
          <el-col :span="12" :xs="{span: 24}">
            <img src="../../assets/module_ir301.png" alt="">
          </el-col>
          <el-col :span="12" :xs="{span: 24}">
            <div class="plain">
              <p><span>名称</span><span>红外遥控模块  DY-IR301</span></p>
              <p><span>无线类型</span><span>万能遥控</span></p>
              <p><span>工作电压</span><span>3.3V</span></p>
              <p><span>天线类型</span><span>红外</span></p>
              <p><span>产品特点</span><span>广角大于90度，窄角小于30度</span></p>
              <p><span>产品尺寸</span><span>35*35*5mm</span></p>
              <p><span>适用范围</span><span>吊灯、吸顶灯、灯带、风扇灯</span></p>
            </div>
            <div class="feature">
              <div>
                <img src="../../assets/icon_jicha.png" alt="">
                <label for="">即插即用</label>
              </div>
              <div>
                <img src="../../assets/icon_wxwg.png" alt="">
                <label for="">无需网关</label>
              </div>
              <div>
                <img src="../../assets/icon_hwyk.png" alt="">
                <label for="">红外遥控</label>
              </div>
              <div>
                <img src="../../assets/icon_ldzn.png" alt="">
                <label for="">联动智能</label>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.section1 {
  margin: 40px 0;
  .el-col {
    position: relative;
    img {
      width: 100%;
    }
    .plain {
      p {
        padding: 0 24px;
        height: 50px;
        display: flex;
        align-items: center;
        span:first-child {
          display: inline-block;
          width: 4em;
          position: relative;
          text-align-last: justify;
          margin-right: 24px;
          flex: 0 0 auto;
          &::after {
            content: ':';
            display: block;
            position: absolute;
            top: 0;
            right: -0.5em;
          }
        }
      }
      p:nth-child(2n + 1) {
        background-color: #ECECEC;
      }
    }
    .feature {
      display: flex;
      justify-content: space-between;
      margin: 40px 0;
      & > div {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        position: relative;
        img {
          width: 80%;
          max-width: 85px;
        }
        label {
          margin: 12px 0;
        }
      }
    }
  }
}

</style>